<template>
  <div class="pagina-container">
    <div :class="[{ 'slot-container': formataConteudo }]">
      <slot />
    </div>
    <div v-if="conteudo && conteudo.length > 10" ref="botoesPaginacao" class="botao-container">
      <div :class="['pagina']" @click="primeiraPagina">
        <font-awesome-icon icon="angle-double-left" />
      </div>
      <div :class="['pagina', 'pagina-prev']" @click="prev">
        <font-awesome-icon icon="angle-left" />
      </div>
      <div @click="vaiParaPagina(item)" v-for="(item, index) in formataPaginas" :key="index">
        <div :class="['pagina', { 'pagina-atual': item == pagina }]">
          {{ item }}
        </div>
      </div>
      <div :class="['pagina', 'pagina-next']" @click="next">
        <font-awesome-icon icon="angle-right" />
      </div>
      <div :class="['pagina']" @click="ultimaPagina">
        <font-awesome-icon icon="angle-double-right" />
      </div>
      <div class="paginacao-perpage">
        <div v-if="!semGrid" class="per-page">
          <b-form-select v-model="quantidadeGrid">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
          </b-form-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Paginacao",
  props: {
    semGrid: String,
    formataConteudo: Boolean,
    produtos: Boolean,
    scrollDown: Boolean,
    conteudo: Array
  },
  data() {
    return {
      pagina: 1,
      quantidadeGrid: 10
    };
  },
  mounted() {
    this.$emit("pagina", this.paginaAtual);
    if (this.semGrid) {
      this.quantidadeGrid = this.semGrid;
    }
  },
  watch: {
    paginaTotal() {
      this.pagina = 1;
    },

    pagina() {
      this.$emit("pagina", this.paginaAtual);
    },
    conteudo: {
      deep: true,
      handler(newVal, oldVal) {
        if (this.produtos) {
          this.$emit("pagina", this.paginaAtual);
        } else if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.$emit("pagina", this.paginaAtual);
        }
      }
    },
    quantidadeGrid() {
      this.$emit("pagina", this.paginaAtual);
    }
  },
  computed: {
    paginaTotal() {
      let total = Math.ceil(this.conteudo.length / this.quantidadeGrid);
      return total;
    },
    paginaAtual() {
      let pagina = this.conteudo.slice(
        (this.pagina - 1) * this.quantidadeGrid,
        this.pagina * this.quantidadeGrid
      );
      return pagina;
    },
    paginas() {
      let paginas = Array.from({ length: this.paginaTotal }, (_, index) => index + 1);
      return paginas;
    },
    formataPaginas() {
      if (this.pagina <= 5) {
        return this.paginas.slice(0, 9);
      }
      if (this.pagina + 5 > this.paginaTotal && this.paginaTotal > 9) {
        return this.paginas.slice(this.paginaTotal - 9, this.paginaTotal);
      }
      if (this.pagina + 5 > this.paginaTotal) {
        return this.paginas;
      }
      if (this.pagina > 5) {
        return this.paginas.slice(this.pagina - 5, this.pagina + 4);
      }
      return this.paginas;
    }
  },

  methods: {
    next() {
      if (this.pagina < this.paginaTotal) {
        this.pagina += 1;
      } else {
        this.pagina = 1;
      }
      this.scroll();
    },
    prev() {
      if (this.pagina > 1) {
        this.pagina -= 1;
      } else {
        this.pagina = this.paginaTotal;
      }
      this.scroll();
    },
    primeiraPagina() {
      this.pagina = 1;
      this.scroll();
    },
    ultimaPagina() {
      this.pagina = this.paginaTotal;
      this.scroll();
    },
    vaiParaPagina(item) {
      this.pagina = item;
      this.scroll();
    },
    scroll() {
      if (this.scrollDown) {
        this.$nextTick(() => {
          window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: "instant"
          });
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pagina {
  background: var(--azul4);
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--branco);
  margin: 0 2px;
  user-select: none;
  cursor: pointer;
}
.slot-container {
  display: flex;
  width: 100%;
  // height: 800px;
  justify-content: center;
  overflow: auto;
}
.botao-container {
  position: relative;
  display: flex;
  width: 100% !important;
  justify-content: center;
  margin-top: 10px;
}
.pagina-atual {
  background: var(--azul1);
  color: var(--azul4);
}
.pagina-prev {
  margin-right: 15px;
}
.pagina-next {
  margin-left: 15px;
}
.paginacao-perpage {
  margin-top: 0;
  top: -5px;
  right: 15px;
}
.pagina-container {
  width: 100%;
}
</style>
